export default __webpack_public_path__ + "0b43afcbd8ca8acd64d947c6e4f38937.png";